import Box from "ds/components/Box";
import { AccessResult } from "utils/access";
import ConfirmRunButton from "components/Run/elements/ConfirmRunButton";
import DiscardRunButton from "components/Run/elements/DiscardRunButton";
import HistoryEntryNote from "components/Run/elements/HistoryEntryNote";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";

import { RunHistoryEntryType } from "../../types";
type UnconfirmedEntryProps = {
  timestamp: number;
  until: number | null;
  note: string | null;
  showDiscardButton: boolean;
  showConfirmButton: boolean;
  canConfirm?: AccessResult;
  canDiscard: AccessResult;
  runId: string;
  stackId: string;
  isStackDisabled: boolean;
  runQueryToRefetch?: string;
};

const UnconfirmedEntry = ({
  timestamp,
  until,
  note,
  showConfirmButton,
  showDiscardButton,
  canConfirm,
  canDiscard,
  runId,
  stackId,
  isStackDisabled,
  runQueryToRefetch,
}: UnconfirmedEntryProps) => {
  return (
    <HistoryEntryWrapper
      state={RunHistoryEntryType.Unconfirmed}
      timestamp={timestamp}
      until={until}
    >
      {note && <HistoryEntryNote>{note}</HistoryEntryNote>}
      <Box gap="medium">
        {canConfirm && showConfirmButton && (
          <ConfirmRunButton
            canConfirm={canConfirm}
            runId={runId}
            stackId={stackId}
            isStackDisabled={isStackDisabled}
            runQueryToRefetch={runQueryToRefetch}
          />
        )}
        {showDiscardButton && (
          <DiscardRunButton
            stackId={stackId}
            runId={runId}
            canDiscard={canDiscard}
            runQueryToRefetch={runQueryToRefetch}
          />
        )}
      </Box>
    </HistoryEntryWrapper>
  );
};

export default UnconfirmedEntry;
